import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    fetchCaseDetail,
    fetchCompanyProfile,
    initiateCaseState,
    proceedCase,
    referCase,
    updateCaseType,
    rejectCase,
    assignCase,
    fetchCaseAssociates,
    fetchCaseBankAccounts,
    updateCaseAssociateStatus,
    GstinsearchList
} from "actions";
import { Map, List } from "immutable";
import {
    Drawer,
    Layout,
    Button,
    PageHeader,
    Row,
    Col,
    notification,
    Menu,
    Modal,
    message,
    Tooltip,
    Input,
    Select,
    DatePicker,
    Spin,
    Tag,
} from "antd";
import { Table } from "components/table";
import _capitalize from "lodash/capitalize";
import { SupplyChainRecord, CaseSanctionRecord } from "records";
import { CaseService } from "services";
import { fetchCaseLedgerMasters } from "services/case-service";
import UnderwritingService from "services/underwriting-service";

import { LoaderSkeleton, DocumentViewer } from "components";
import { CASE_VIEW_ACTION, STATE_STATUS } from "constants";
import "styles/case-details.css";
import "styles/drawer-overrides.css";
import { CompanyService } from "../../services";
import { fetchEnums } from "actions";
import { fetchCompanyDocuments, fetchCamEngineView, fetchPortfolioView, fetchCamEngineViewComments, fetchCamEngineStatusLogs } from 'store/actions'
import moment from 'moment';
import { DEFERRAL_CATEGORY } from 'constants/index';
import FoundersCaseDetailsSummary from "./case-detail-summary-founders";
import CAMView from "../case-details-tabs/cam-view";
import { CAMS_VIEW_FOUNDERS } from "../../constants/columns";
import RemarksEditor from "../case-details-tabs/remarks-editor";

const { TextArea } = Input;
const { Option } = Select;

class FounderCaseDetailsDrawer extends React.Component {
    state = {
        visible: !!this.props.caseId,
        expanded: false,
        isRiskApprover: null,
        action: null,
        takeAction: false,
        showDocuments: false,
        disableActionButton: false,
        documentsList: [],
        casesList: new List([]),
        fetchedCasesList: false,
        showSupplyChainRemarks: false,
        are_sellers_same: false,
        ledger_masters: [],
        caseLedgerStatus: null,
        sales_manager_users: [],
        inside_sales_persons: [],
        asm_data: null,
        isp_data: null,
        showPullBackRemark: false,
        showError: false,
        remarksValue: "",
        pullbackloader: false,
        showCaseMovementBtns: {},
        openChecklistModalUnAssign: false,
        onChangeReasonUnAssign: "",
        fetchCaseAssocicate: true,
        dbViewTableData: [],
        anchorViewTableData: [],
        geoViewTableData: [],
        stateViewTableData: [],
        camEngineData: [],
        deferralEndDate: null,
        categoryDeferral: [],
        actionDeferral: "",
        remarksDeferral: "",
        actionReasonsList: [],
        activeCamCategoryFilter: '',
        camEngineTableData: []
    };
    isLoading() {
        if (!this.props.status || this.props.status !== STATE_STATUS.FETCHED) {
            return true;
        }
        return false;
    }
    getActionModal = action => {
        this.setState({
            disableActionButton: true
        });
        let caseAssociates = this.props.caseAssociates &&
            this.props.caseAssociates.filter(_ => [1, 2].includes(_.type))
                .map(_ => Number(_.company_associate.id));
        let associates = this.props.company &&
            this.props.company.associates &&
            this.props.company.associates.filter(_ => caseAssociates && caseAssociates.includes(Number(_.id)))
                .map(_ => ({
                    id: _.id,
                    name: `${_.first_name || ""} ${_.last_name || ""}`
                }))
                .toList().toArray();
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_actions: {
                case_id: this.props.caseId,
                case_task_id: this.props.case_task_id,
                stage_id: this.props.stageId,
                associates,
                companyId: this.props.companyId,
                stageName: this.props.stageName,
                action: action,
                params: this.props.location.pathname,
            }
        });
    };
    closeActionModal = () => {
        this.setState({
            takeAction: false,
            action: null,
            disableActionButton: true
        });
    };

    openDocumentsDrawer = (documents, doc, fileName) => {
        let docsList =
            documents &&
            documents.size &&
            documents.map(_ => (
                {
                    file: _.getIn(["data", "file", "file"]),
                    fileName: _.getIn(["data", "file", "file_name"])
                }
            ));
        this.setState({
            showDocuments: true,
            documentsList: docsList ? docsList : new Map({ fileObj: { file: doc, fileName } })
        });
    };

    closeDocumentsDrawer = () => {
        this.setState({
            showDocuments: false
        });
    };

    upgradeCaseButtonsEnabled = () => {
        this.setState({
            disableActionButton: false
        });
    };

    componentDidMount() {
        this.props.fetchCamEngineView(this.props.caseId);
        if (this.props.caseId) {
            this.props.initiateCaseState(this.props.caseId);
        }
        this.props.fetchEnums();
        this.props.fetchPortfolioView(this.props.caseId);
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION
        ) {
            this.props.fetchCaseDetail(this.props.caseId);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseAssociatesStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseAssociates(this.props.caseId);
        }

        // if (
        //     this.props.caseId &&
        //     this.props.action === CASE_VIEW_ACTION &&
        //     (this.props.caseBankAccountsStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        // ) {
        //     this.props.fetchCaseBankAccounts(this.props.caseId);
        // }

        if (
            this.props.status === STATE_STATUS.FETCHED &&
            this.props.companyStatus &&
            this.props.companyStatus.get("companyStatus") ===
            STATE_STATUS.FETCHED
        ) {
            this.setState({
                visible: true
            });
        }
        if (
            this.props.userStatus === "FETCHED" &&
            this.state.isRiskApprover === null
        ) {
            let group =
                this.props.user &&
                this.props.user
                    .getIn(["data", "groups"])
                    .filter(_ => _.id == 8);
            this.setState({
                isRiskApprover: (group.size || group.length) ? true : false
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.camEngineStatus == STATE_STATUS.FETCHED && prevProps.camEngineStatus == STATE_STATUS.FETCHING) {
            this.creditEnhancementDbViewFn();
        }

        if (this.props.deleteAssociateStatus == STATE_STATUS.FETCHED) {
            this.props.fetchCaseAssociates(this.props.caseId);
            this.props.updateCaseAssociateStatus(this.props.caseId, STATE_STATUS.UNFETCHED);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseAssociatesStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseAssociates(this.props.caseId);
        }
        if (
            this.props.caseId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.caseBankAccountsStatus === STATE_STATUS.UNFETCHED || !this.props.status)
        ) {
            this.props.fetchCaseBankAccounts(this.props.caseId);
        }
        if (
            this.props.status === STATE_STATUS.FETCHED &&
            this.props.companyStatus &&
            this.props.companyStatus.get("companyStatus") ===
            STATE_STATUS.FETCHED &&
            !this.state.visible
        ) {
            this.setState({
                visible: true
            });
        }
        if (
            this.props.companyId &&
            this.props.action === CASE_VIEW_ACTION &&
            (!this.props.companyStatus ||
                this.props.companyStatus.get("companyStatus") ===
                STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchCompanyProfile(this.props.companyId, this.props.caseId);
        }
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.disableActionButton === false &&
            this.state.disableActionButton
        ) {
            this.setState({
                disableActionButton: false
            });
        }
        if (this.props.company && this.props.caseDetail && !this.state.fetchingLedgerMaster) {
            this.fetchLedgerMasters();
        }
        if (this.props.caseDetail && prevProps.status !== this.props.status && this.props.status === "FETCHED") {
            this.props.caseId && CompanyService.getCaseMovementBtns(this.props.caseId).then(({ data }) => {
                this.setState({
                    showCaseMovementBtns: data
                });
            }).catch((err) => {
                console.log("inside btns data catch", err);
            });
        }
        if (this.state.fetchingLedgerMaster && prevProps.status !== this.props.status && this.props.status === "FETCHED") {
            this.fetchLedgerMasters();
        }
        if (prevState.remarksDeferral === "" && (prevProps?.caseDetail?.deferral_tagged || prevProps?.caseDetail?.deferral_tagged === false)) {
            const { deferral_tagged, deferral_json } = prevProps.caseDetail;
            const remarks = deferral_tagged
                ? deferral_json?.tag_remarks
                : deferral_json?.untag_remarks;
            if (remarks !== this.state.remarksDeferral) {
                this.setState({
                    remarksDeferral: remarks,
                    categoryDeferral: deferral_json?.category,
                    actionDeferral: deferral_json?.action == true && "Yes" || deferral_json?.action == false && "No",
                    deferralEndDate: moment(deferral_json?.end_date)
                });
            }
        }
    }

    creditEnhancementDbViewFn = () => {
        const camsApiData = this.props.camEngineData;
        for (let key in camsApiData) {
            if (camsApiData.hasOwnProperty(key)) {
                camsApiData[key].key2 = key;
            }
        }
        const sortedData = camsApiData && Object.entries(camsApiData).sort(([keyA], [keyB]) => {
            const lastPartA = keyA.split('_').pop();
            const lastPartB = keyB.split('_').pop();

            const isIntA = !isNaN(lastPartA);
            const isIntB = !isNaN(lastPartB);

            if (isIntA && isIntB) {
                return parseInt(lastPartA) - parseInt(lastPartB);
            } else if (isIntA) {
                return 1;
            } else if (isIntB) {
                return -1;
            } else {
                return 0;
            }
        });
        const sortedObject = Object.fromEntries(sortedData);
        const CamViewDataApi = camsApiData && Object.values(sortedObject);

        const camsViewData = [];
        const CamViewDataApi_final = CamViewDataApi.filter(_ => _.key2 != 'sanction_limit_to_monthly_sales_ratio' && _.key2 != 'primary_banker' && _.key2 != 'percentage_total_outstanding_payable' &&
            _.key2 != 'growth_gst_turnover_24_months' && _.key2 != 'geo_portfolio_in_due_date' && _.key2 != 'geo_portfolio_in_90_plus_dpd' && _.key2 != 'db_profitability' &&
            _.key2 != 'db_portfolio_in_due_date' && _.key2 != 'db_portfolio_in_90_plus_dpd' && _.key2 != 'anchor_name' && _.key2 != 'stop_supply' && _.key2 != 'scheme_check' &&
            _.key2 != 'recourse_perc' && _.key2 != 'program_size_os' && _.key2 != 'stock_liquidation' && _.key2 != 'recourse_structure' && _.key2 != 'anchor_profitability' &&
            _.key2 != 'termination_intimation' && _.key2 != 'anchor_portfolio_in_due_date' && _.key2 != 'anchor_portfolio_in_90_plus_dpd' && _.key2 != 'sub_lss_dbt_reported_last_12_month' && _.key2 != 'written_off_and_settle_within_12_month' &&
            _.key2 != 'mpa_risk_category' && _.key2 != 'mpa_anchor_recommendation' && _.key2 != 'dscr' && _.key2 != 'net_working_capital' && _.key2 != 'interest_service_coverage_ratio' && _.key2 != 'emi_obligations' &&
            _.key2 != 'abb_emi_obligations' && _.key2 != 'retailer_risk_holdback_perc'
        );

        CamViewDataApi_final.forEach((el, idx) => {
            return (
                camsViewData.push({
                    "s_no": idx + 1,
                    "category": el?.category,
                    "fact_name": el?.fact_name,
                    "fact_value": el?.fact_value === true ? "True" : (el?.fact_value === false || el?.fact_value === "" || el?.fact_value === null) ? "False" : el?.fact_value,
                    "policy": typeof el?.policy == "boolean" ? String(el?.policy) : el?.policy || "NA",
                    "output": el?.output === true ? "Pass" : el?.output === false ? "Fail" : "Not Applicable",
                    "deviation": el?.deviation === "Yes" ? el.deviation_reason : el?.deviation === "No" ? "" : "",
                    "key2": el?.key2,
                    "approval_mandatory": el?.approval_mandatory,
                    "credit_remarks": el?.credit_remarks,
                    "approval_level": el?.approval_level
                }));
        });
        const categoryOrder = ["Profile", "General", "Ledger", "Banking", "GST", "Financial", "Geography", "DB", "Anchor", "Anchor MPA", "Bureau", "MPA", "Financials"];
        let output = this.groupByCategory(camsViewData, categoryOrder)
        output = Object.keys(output).map(_ => output[_]).flat()

        this.setState({ camEngineTableData: output });
    }

    groupByCategory(data, order) {
        const groupedData = {};

        // Initialize groupedData with empty arrays for each category in order
        order.forEach(category => {
            groupedData[category] = [];
        });

        // Group items by category
        data.forEach(item => {
            const category = item.category;
            if (groupedData.hasOwnProperty(category)) {
                groupedData[category].push(item);
            }
        })
        return groupedData;
    }


    fetchLedgerMasters = () => {
        this.setState({
            fetchingLedgerMaster: true
        }, async () => {
            const { company, caseDetail } = this.props;
            const { data: ledger_masters } = await fetchCaseLedgerMasters(caseDetail.id);
            const { data: gstin_ledger_masters } = await UnderwritingService.getSupplyChainListByGSTIN(company.gstin);
            gstin_ledger_masters.map(_ => {
                if (!ledger_masters.find(__ => __.ledger_analysis && __.ledger_analysis.id === _.id || _.id === __.id)) {
                    ledger_masters.push({ ..._, checked: false });
                }
            });
            const ledger_master_distinct_sellers = [...new Set(ledger_masters.map(_ => _.seller && Number(_.seller.id)))].sort();
            const case_distinct_sellers = [...new Set(caseDetail.sellers && caseDetail.sellers.map(_ => Number(_.id)))].sort();
            let are_sellers_same = true;
            if (ledger_master_distinct_sellers.length === case_distinct_sellers.length) {
                ledger_master_distinct_sellers.map((_, k) => {
                    if (_ !== case_distinct_sellers[k]) {
                        are_sellers_same = false;
                    }
                });
            } else {
                are_sellers_same = false;
            }
            if (this.props.stageId == 56) {
                are_sellers_same = true;
            }
            this.setState({
                are_sellers_same
            });
        });

    }

    handleGuarantorNotification() {
        if (
            !this.notificationShowed &&
            this.props.companyId &&
            this.props.action === CASE_VIEW_ACTION &&
            (this.props.companyStatus &&
                this.props.companyStatus.get("companyStatus") ===
                STATE_STATUS.FETCHED)
        ) {
            if (this.props.company.isGuarrantorRequired && ![9, 14].includes(+this.props.stageId)) {
                this.notificationShowed = true;
                notification.warn({
                    message: "Guarantor Required",
                    description:
                        "One of the associates have the age > 65 or age <25"
                });
            }
        }
    }

    onDrawerClose = () => {
        this.setState(
            {
                visible: false
            },
            () => {
                this.props.history.goBack();
            }
        );
    };
    toggleExpand = () => {
        this.setState({
            expanded: !this.state.expanded
        });
    };
    viewCaseNotes = () => {
        this.props.history.push(this.props.location.pathname, {
            ...this.props.location.state,
            case_notes: {
                caseId: this.props.caseId,
                stageId: this.props.stageId,
                case_notes_view: true
            }
        });
    };
    openCaseMetaDrawer = () => {
        const { location: { pathname, state: locationState }, caseId } = this.props;
        this.props.history.push(pathname, {
            ...locationState,
            case_meta: {
                caseId
            }
        });
    }

    handleMenuClick = (val) => {
        const modal = Modal.confirm();
        modal.update({
            title: "Are you sure?",
            content: "This will go to the Sales Cordinator.",
            onOk: () => this.props.updateCaseType(this.props.caseId, val.key),
            onCancel: () => { },
            okText: "Yes",
            cancelText: "No"
        });
    }

    menu = (
        <Menu onClick={this.handleMenuClick}>
            <Menu.Item key="2">
                Enhance
            </Menu.Item>
            <Menu.Item key="3">
                Renew
            </Menu.Item>
            <Menu.Item key="4">
                Amendment
            </Menu.Item>
        </Menu>
    );

    getMenu = (menuArr) => (
        <Menu>
            {menuArr.map(_ => {
                if (_.children) {
                    return (
                        <Menu.SubMenu
                            key={_.key}
                            title={_.label}
                        >
                            {_.children}
                        </Menu.SubMenu>
                    );
                }
                return (
                    <Menu.Item
                        key={_.key}
                        size={"small"}
                        className={_.className}
                        onClick={_.onClick}
                        htmlType={_.htmlType || "button"}
                        disabled={_.disabled}>
                        {_.label}
                    </Menu.Item>
                );
            }
            )}
        </Menu>
    );

    checkIfSalesCoordinator() {
        const loggedInUser = this.props.user.getIn(["data", "id"]);
        if (
            this.props.userGroups &&
            this.props.userGroups.includes(3)
        ) {
            return true;
        }
        if (
            loggedInUser &&
            this.props.currentCaseTask &&
            this.props.currentCaseTask.this_user &&
            this.props.currentCaseTask.this_user.id &&
            Number(loggedInUser) == Number(this.props.currentCaseTask.this_user.id)
        ) {
            return true;
        }
        return false;
    }

    casePullBack = () => {
        if (this.state.remarksValue) {
            let remarkData = { "pull_back_remarks": this.state.remarksValue, "action_reason": this.state.pullBackActionReason };
            this.setState({
                pullbackloader: true
            });
            CompanyService.postPullBack(this.props.caseId, remarkData).then(() => {
                message.success("Case Moved Successfully to Credit Appraisal!");
                this.setState({
                    remarksValue: "",
                    showError: false,
                    showPullBackRemark: false,
                    pullbackloader: false
                }, () => window.location.reload());
            }).catch((err) => {
                message.error(err?.message?.[0]);
                this.setState({ pullbackloader: false });
            });
        } else {
            this.setState({
                showError: true,
            });
        }
    }

    getActionModalUnassign = () => {
        this.setState({ openChecklistModalUnAssign: true });
    }

    closeModalUnAssign = () => {
        this.setState({
            openChecklistModalUnAssign: false
        });
    }

    onUnAssigningCase = () => {
        let finalData = { "remarks": this.state.onChangeReasonUnAssign, "action_reason": this.state.onChangeReasonUnAssign };
        try {
            this.state.onChangeReasonUnAssign ? CaseService.UnAssignCase(this.props.case_task_id, finalData).then(res => {
                res.status === 200 && message.success("Case has been Un-Assigned"), this.setState({ openChecklistModalUnAssign: false }),
                    this.props.history.goBack();
            }).catch((error) => {
                if (error && error.status == 404) {
                    message.error(error.data.detail);
                }
                if (error && error.non_field_errors && error.non_field_errors.length) {
                    error.non_field_errors.map(_ => {
                        message.error(_);
                    });
                }
                this.setState({ openChecklistModalUnAssign: false });
            }) : message.error("Please enter remarks.");
        } catch (err) {
            message.error("Something went wrong!");
        }
    }

   

    caseActions = () => {
        let buttonFinalArr = [];
        
        buttonFinalArr.push(<Button
            icon="close"
            type={"danger"}
            onClick={() => {
                this.showRejectConfirm()
                // this.approveRejectAuthorityApproval("Rejected");
            }}
        >Reject</Button>)
        buttonFinalArr.push(<Button
            icon="check"
            type={"primary"}
            onClick={() => {
                this.showApproveConfirm()
                // this.approveRejectAuthorityApproval("Approved");
            }}
        >
            Approve
        </Button>)
        if(['pallavi@progcap.com', 'himanshu@progcap.com'].includes(this.props.user.getIn(['data', 'email']))){
            return buttonFinalArr;
        }
        return []
    };

    approveRejectAuthorityApproval = (status, remarks = "") => {
        if (['pallavi@progcap.com', 'himanshu@progcap.com'].includes(this.props.user.getIn(['data', 'email']))) {
            CaseService.approveRejectAuthorityApprovalFounders(this.props.caseId, this.props.user.getIn(['data', 'email'])[0].toUpperCase(), status, remarks)
                .then((resp) => {
                    message.success(resp.data.status)
                })
        } else {
            message.error("You don’t have the required permissions to approve or reject this request. Please contact the system admin if you believe this is incorrect.")
        }


    }

    showApproveConfirm = () => {
        const t = this;
        Modal.confirm({
            title: "Are you sure you want to approve?",
            content: "",
            okText: "Approve",
            okType: "primary",
            onOk() {
                t.approveRejectAuthorityApproval("Approved")
                // console.log("Approved");
            },
        });
    };

    showRejectConfirm = () => {
        let remarks = "";
        const t = this;
        Modal.confirm({
            title: "Are you sure you want to reject?",
            content: (
                <div>
                    <p>Please provide remarks</p>
                    <TextArea
                        rows={3}
                        placeholder="Enter remarks"
                        onChange={(e) => (remarks = e.target.value)}
                    />
                </div>
            ),
            okText: "Reject",
            okType: "danger",
            onOk() {
                // if (!remarks) {
                //     Modal.error({
                //         title: "Remarks required",
                //         content: "Please enter remarks before rejecting.",
                //     });
                //     return Promise.reject();
                // }
                t.approveRejectAuthorityApproval("Rejected", remarks)
                console.log("Rejected with remarks:", remarks);
            },
        });
    };

    getCompanyId = (name, companyId) => {
        var result = name && name.toLowerCase().replace(/\w+/g, _capitalize);
        return (
            <React.Fragment>
                <Tooltip title={`${result} (${companyId})`}>
                    <span className={"company"}>
                        {result}
                    </span>
                </Tooltip>
                <span style={{
                    color: "#f9f9f9"
                }}>{` (${companyId})`}</span>
            </React.Fragment>
        );
    }

    onScrollFn = (e) => {
        const scrollingPos = e.target?.scrollTop;
        sessionStorage.setItem("scrollPositionDocReview", scrollingPos);
    }

    updateDocList = (caseId, companyId) => {
        this.props.fetchCompanyDocuments(caseId, companyId)
    }

    onDeferral = () => {
        let body;
        if (this.state.actionDeferral === "No") {
            body = this.props.caseDetail?.deferral_tagged === null ?
                { "action": "False" } :
                {
                    "action": "False",
                    "untag_remarks": this.state.remarksDeferral.trim()
                };
        } else {
            body = {
                "action": "True",
                "category": [...this.state.categoryDeferral],
                "end_date": this.state.deferralEndDate?._isAMomentObject ? this.state.deferralEndDate.format('YYYY-MM-DD') : null,
                "tag_remarks": this.state.remarksDeferral.trim()
            };
        }
        const validateBody = (body) => {
            for (let key in body) {
                if (body[key] === null || body[key] === "undefined" || body[key] === "" || (Array.isArray(body[key]) && body[key].length === 0)) {
                    return false;
                }
            }
            return true;
        };
        if (validateBody(body)) {
            CaseService.deferralTag(this.props.caseId, this.state.actionDeferral, body).then(res => {
                if (res.status === 200 && this.state.actionDeferral === "No" && res?.data?.untag_remarks) {
                    message.success("Deferral Closed");
                }
                if (res.status === 200 && this.state.actionDeferral === "No" && !res?.data?.untag_remarks) {
                    message.success(res?.data?.message || "Deferral Not Opted");
                }
                if (res.status === 200 && this.state.actionDeferral === "Yes") {
                    message.success("Deferral Created");
                }
                this.props.fetchCaseDetail(this.props.caseId);
            }).catch(err => {
                console.log("inside catch", err);
            }).finally(() => {
                this.setState({ deferralModal: false })
            })
        } else {
            message.error("Please fill all required fields before submitting.");
        }
    }

    handleDateInput = (val) => {
        this.setState({ deferralEndDate: val })
    }

    onSelectReasonCategory = val => {
        let reasonCategory = this.state.actionReasonsList && this.state.actionReasonsList.find(_ => _.id == val);
        if (reasonCategory) {
            this.setState({
                pullBackActionReason: reasonCategory.name,
            });
        }
    }

    renderCamFilter = () => {
        const { activeCamCategoryFilter } = this.state;
        const categoryOrder = ["Profile", "General", "Ledger", "Banking", "GST", "Financial", "Geography", "DB", "Anchor", "Anchor MPA", "Bureau", "MPA", "Financials"];

        return (
            <Row>
                <Col span={24}>
                    {categoryOrder.map(category => (
                        <Button
                            key={category}
                            style={{ color: activeCamCategoryFilter === category ? '#fff' : '#000' }}
                            type={activeCamCategoryFilter === category ? 'primary' : 'link'}
                            onClick={() =>
                                this.setState({ activeCamCategoryFilter: category })
                            }
                        >
                            {category}
                        </Button>
                    ))}
                </Col>
            </Row>
        );
    };
    renderCamView = () => {
        if (!this.props.camEngineDataGroup || !this.state.activeCamCategoryFilter) {
            return <div></div>
        }
        return <div>
            <div style={{ padding: 10, minHeight: 550 }}>
                <h3>Credit Parameters</h3>
                {this.props.camEngineDataGroup[this.state.activeCamCategoryFilter] && this.props.camEngineDataGroup[this.state.activeCamCategoryFilter].map((_, key) => {
                    return <Col xs={24} sm={12} md={8} lg={8} style={{ marginBottom: 10 }} ><div class="cam-card">
                        <div class="card-header">
                            <span class="category">{_.category} <span class="count">#{key + 1}</span></span>
                            {_.output ? <Tag color='#87d068'>Pass</Tag> : <Tag color='#f50'>Fail</Tag>}
                        </div>

                        <div class="title">{_.fact_name}</div>

                        <div class="meta">
                            <div><strong>Policy:</strong> {_.policy}</div>
                            <div class="value">
                                <strong>Value:</strong> ${_.fact_value}
                                <span class="approval">Approval: {_.approval_level}</span>
                            </div>
                        </div>

                        <div class="remark">
                            <input type="text" placeholder="Add a remark..." />
                            <button class="send-btn">➤</button>
                        </div>
                    </div>
                        {/* <p>{_.category}</p>
                        <p>{_.fact_name}</p>
                        <p>{_.fact_value}</p> */}
                    </Col>
                })}
            </div>
        </div>
    }

    getCustomTag = (_, key) => {
        if (key == "deviation") {
            return <label className="br-4" style={{ backgroundColor: _ === "Yes" ? "#f4f494" : "" }}> {_} </label>
        }
        return <div style={{ width: "100%" }}><label
            className="txt-light br-4"
            style={{ backgroundColor: _ === "Pass" ? "rgb(134 220 134)" : _ === "Fail" ? "rgb(238 142 142)" : "rgb(226 226 30)", textAlign: 'center', display: "inline-block", width: "90%" }}
        >
            {_}
        </label></div>
    }

    render() {
        const {
            name,
            caseDetail,
            companyId,
        } = this.props;
        const systemRecommendation = caseDetail && caseDetail.recommendation_status;
        let system_recommendation_bg = "#6fac95";
        if (systemRecommendation === "Rejected") {
            system_recommendation_bg = "#FFA79C";
        }
        if (systemRecommendation === "In Review") {
            system_recommendation_bg = "#F9E9D2";
        }
        const recreditViewOnlyPermission = this.props.caseDetail?.toJS().current_case_task?.some(el => el.this_stage === 42);
        const today = moment();

        const endDate = moment().add(30, 'days');
        function disabledDateFn(current) {
            return current && (current < today ||
                current > endDate);
        }
        if (caseDetail == undefined) {
            return <>
                <Spin spinning={true}></Spin>
            </>
        }
        return (
            <React.Fragment>
                    <Layout style={{ height: "inherit" }}>
                        <LoaderSkeleton loading={this.isLoading()}>
                            <Row className={"case-detail-row"} onScroll={this.onScrollFn}>
                                <Col span={24} className={"case-detail-page-header"}>
                                    <PageHeader
                                        className={"drawerExtraButtons company-name"}
                                        title={this.getCompanyId(name, companyId)}
                                        // onBack={this.onDrawerClose}
                                        extra={this.caseActions()}
                                    />
                                </Col>
                                <Col span={24} className={`p-base case-detail-summary ${caseDetail && caseDetail.is_deviation_allowed === false && "mt-10"}`}>
                                    <FoundersCaseDetailsSummary
                                        userGroups={this.props.userGroups}
                                        {...(this.isLoading()
                                            ? {}
                                            : caseDetail.getSummary())}
                                        caseType={this.props.currentCaseType}
                                        caseId={this.props.caseId}
                                        companyId={this.props.companyId}
                                        company={this.props.company}
                                        recreditViewOnlyPermission={recreditViewOnlyPermission}
                                        stageId={this.props.stageId}
                                        permissions={this.props.permissions}
                                        data={this.props.caseDetail}
                                        tenor={this.props.caseDetail && this.props.caseDetail.tenure || "--"}
                                        scheme_roi={this.props.caseDetail && this.props.caseDetail.scheme_roi || "--"}
                                        stop_billing_days={this.props.caseDetail && this.props.caseDetail.stop_billing_days || "--"}
                                        stageName={this.props.stageName}
                                        isInbox={this.props.is_inbox}
                                        proposed_limit={
                                            this.props.proposed_limit
                                        }
                                        asm_data={
                                            this.props.caseDetail && this.props.caseDetail.get("sales_manager_user")
                                            // this.state.asm_data
                                        }
                                        isp_data={
                                            this.props.caseDetail && this.props.caseDetail.get("inside_sales_personnel")
                                        }
                                        sales_manager_users={
                                            this.state.sales_manager_users
                                        }
                                        inside_sales_persons={
                                            this.state.inside_sales_persons
                                        }
                                        risk_sharing_percentage={this.props.caseDetail && this.props.caseDetail.risk_sharing_percentage}
                                        currentCaseType={this.props.currentCaseType}
                                        fetchCaseDetail={this.props.fetchCaseDetail}
                                        portfolioViewData={this.props.portfolioViewData}
                                        portfolioViewStatus={this.props.portfolioViewStatus}
                                    />
                                </Col>
                                <Col span={24} className="p-base">
                                    <h5>Case Summary</h5>
                                    <RemarksEditor
                                        hideTitle={true}
                                        remarks={this.props.caseDetail.remarks}
                                        readOnly={true}
                                    />
                                </Col>
                                {/* <CAMView
                                    camEngineData={this.props.camEngineData} 
                                    camEngineStatus={this.props.camEngineStatus}
                                    fetchCamEngineView={this.props.fetchCamEngineView} 
                                    fetchCamEngineStatusLogs={this.props.fetchCamEngineStatusLogs}
                                    fetchCaseDetail={this.props.fetchCaseDetail}
                                    isEmbedded={true}
                                    {...this.props}
                                />  */}
                                {/* <Col span="24">{this.renderCamFilter()}</Col> */}

                                {/* {this.renderCamView()} */}
                                <Col span={24} className={`p-base pt-0 case-detail-summary`}>
                                    <h5>Credit Parameters</h5>
                                    <div
                                        className="mobile-table-wrapper"
                                    >
                                        <Table
                                            bordered
                                            className="ant-col padless-card custom-align-table-body-cam compact-table"
                                            columns={CAMS_VIEW_FOUNDERS(this.getCustomTag)}
                                            rowBGColor={"red"}
                                            rowClassName={(record, index) => record.approval_mandatory ? "bgRed" : ""}
                                            data={List(this.state.camEngineTableData).map((_, k) => {
                                                let row = _;
                                                if (row && typeof row === "object") {
                                                    row.key = k;
                                                    // row.sno = k+1;
                                                    row.value = _.value;
                                                    row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                                    row.credit_remarks = _.credit_remarks;
                                                }
                                                return row;
                                            }).toList()}
                                            size="middle"
                                            pagination={false}
                                            showTopSection={false}
                                            showFilters={false}
                                            noRowSelection={true}
                                            editable={true}
                                            scrollY={false}
                                            scrollX={false}
w                                        />
                                    </div>
                                </Col>
                                <Col span={24}>
                                    <Table
                                        title={<h5>Summary of Deviations</h5>}
                                        spanConfig={{
                                            title: 8,
                                        }}
                                        bordered
                                        className="ant-col padless-card custom-align-table-body-cam compact-table"
                                        columns={
                                            CAMS_VIEW_FOUNDERS(this.getCustomTag).filter(el => el.breachedPara)
                                        }
                                        showColumnSelector={false}
                                        showCustomButtons={true}
                                        rowBGColor={"red"}
                                        rowClassName={(record, index) => record.approval_mandatory ? "bgRed" : ""}
                                        data={List(this.state.camEngineTableData).filter(el => el.output === "Fail").map((_, k) => {
                                            let row = _;
                                            if (row && typeof row === "object") {
                                                row.key = k;
                                                // row.sno = k+1;
                                                row.value = _.value;
                                                row.review_category = _.deviation === "No" ? _.review_category || "OK" : _.review_category;
                                                row.credit_remarks = _.credit_remarks;
                                            }
                                            return row;
                                        }).toList()}
                                        size="middle"
                                        pagination={false}
                                        showTopSection={true}
                                        showFilters={false}
                                        noRowSelection={true}
                                        editable={true}
                                        scrollY={500}
                                    /></Col>
                            </Row>
                        </LoaderSkeleton>
                    </Layout>
            </React.Fragment>
        );
    }
}

FounderCaseDetailsDrawer.defaultProps = {
    status: STATE_STATUS.UNFETCHED,
    supplyChainDetail: new SupplyChainRecord(),
    caseSanction: new CaseSanctionRecord(),
};

FounderCaseDetailsDrawer.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    action: PropTypes.string,
    companyId: PropTypes.number,
    company: PropTypes.object,
    companyStatus: PropTypes.object,
    caseId: PropTypes.number,
    tab: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    caseDetail: PropTypes.object,
    fetchCaseDetail: PropTypes.func,
    fetchCompanyProfile: PropTypes.func,
    initiateCaseState: PropTypes.func,
    //Routing State
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    //
    supplyChainDetail: PropTypes.object,
    caseSanction: PropTypes.object,
    stagePermissions: PropTypes.object,
    stageId: PropTypes.number,
    stageName: PropTypes.string,
    stages: PropTypes.object,
    case_task_id: PropTypes.number,
    is_inbox: PropTypes.bool,
    children: PropTypes.array,
    proceedCase: PropTypes.func,
    referCase: PropTypes.func,
    rejectCase: PropTypes.func,
    user: PropTypes.object,
    userStatus: PropTypes.string,
    upgradedCasesStatus: PropTypes.string,
    proposed_limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userGroups: PropTypes.array,
    isUserAllowedToEdit: PropTypes.bool,
    currentStageUser: PropTypes.number,
    updateCaseType: PropTypes.func,
    isCaseUnAssigned: PropTypes.bool,
    assignCase: PropTypes.func,
    assignedUsers: PropTypes.array,
    isCaseRejectedOrHold: PropTypes.bool,
    currentCaseType: PropTypes.number,
    isParentCaseExist: PropTypes.bool,
    cases: PropTypes.object,
    caseOpenedFromDrawer: PropTypes.bool,
    currentCaseTask: PropTypes.object,
    stageAdminIds: PropTypes.array,
    fetchCaseAssociates: PropTypes.func,
    caseAssociatesStatus: PropTypes.string,
    caseAssociates: PropTypes.array,
    caseBankAccountsStatus: PropTypes.string,
    caseBankAccounts: PropTypes.array,
    fetchCaseBankAccounts: PropTypes.func,
    asm_data: PropTypes.object,
    permissions: PropTypes.object,
    isp_data: PropTypes.object,
    GstinsearchList: PropTypes.string,
    updateCaseAssociateStatus: PropTypes.func,
    deleteAssociateStatus: PropTypes.string,
    camEngineStatus: PropTypes.string,
    camEngineViewData: PropTypes.object,

};

const mapStateToProps = (
    state,
    { location: { state: lState }, match: { params }, props }
) => {
    const companyId = state.caseDetails &&
        state.caseDetails.getIn([Number(params.caseId), "data", "company"]);
    const user = state.user.getIn(["data", "id"]);
    const adminGroup = state.user.getIn(["data", "stage_admin"]);
    const current_case_task = state.caseDetails &&
        state.caseDetails.getIn([Number(params.caseId), "status"]) === "FETCHED" &&
        state.caseDetails.getIn([Number(params.caseId), "data"]).getCurrentCaseTask(user, adminGroup);
    const caseDetail = state.caseDetails.getIn([Number(params.caseId), "data"]);
    return {
        caseOpenedFromDrawer: lState && lState.case_details && lState.case_details.caseOpenedFromDrawer,
        caseId: Number(params.caseId),
        cases: state.cases,
        user: state.user,
        userGroups: state.user && state.user.getIn(["data", "groups"]).map(_ => _.id),
        userStatus: state.user.get("status"),
        case_task_id:
            current_case_task && current_case_task.id,
        currentStageUser: current_case_task && current_case_task.this_user && current_case_task.this_user.id,
        isUserAllowedToEdit:
            state.user &&
            current_case_task &&
            current_case_task.this_user &&
            current_case_task.this_user.id === state.user.getIn(["data", "id"]) &&
            ![2, 4, 5].includes(caseDetail && caseDetail.case_status),
        is_inbox: location.pathname.includes("inbox"),
        tab: params.tabId,
        action: CASE_VIEW_ACTION,
        name: state.companies.getIn([companyId, "data", "name"]),
        status: params.caseId
            ? state.caseDetails.getIn([Number(params.caseId), "status"])
            : null,
        companyId: companyId,
        companyStatus:
            companyId ?
                state.companies.getIn([
                    companyId,
                    "status"
                ])
                : null,
        company:
            companyId
                ? state.companies.getIn([companyId, "data"])
                : null,
        caseDetail: params.caseId
            ? state.caseDetails.getIn([Number(params.caseId), "data"])
            : null,
        stageId: current_case_task && current_case_task.this_stage,
        stageName:
            current_case_task
                ? (
                    state.stages
                        .get("data")
                        .find(_ => _.id === current_case_task.this_stage) || {
                        stage_name: null
                    }
                ).stage_name
                : null,
        assignedUsers: state.caseDetails.getIn([Number(params.caseId), "data", "current_case_task"]),
        isCaseUnAssigned: !!(state.caseDetails.getIn([Number(params.caseId), "data", "current_case_task"]) || [{ this_user: null }]).find(_ => !_.this_user),
        isCaseRejectedOrHold: [2, 4, 5].includes(state.caseDetails.getIn([Number(params.caseId), "data", "case_status"])),
        currentCaseType: state.caseDetails.getIn([Number(params.caseId), "data", "case_type"]),
        stagePermissions: state.stagePermissions,
        permissions: state.user.getIn(["permissions"]),
        stages: state.stages.get("data"),
        proposed_limit: state.caseDetails.getIn([
            Number(params.caseId),
            "data",
            "proposed_limit"
        ]),
        upgradedCasesStatus: state.upgradedCases.get(
            current_case_task && current_case_task.id
        ),
        isParentCaseExist: !!state.caseDetails.getIn([Number(params.caseId), "data", "parent_case_detail"]),
        currentCaseTask: current_case_task,
        stageAdminIds: state.user.getIn(["data", "stage_admin"]),
        caseAssociatesStatus: state.caseDetails.getIn([Number(params.caseId), "caseAssociates", "status"]),
        caseAssociates: state.caseDetails.getIn([Number(params.caseId), "caseAssociates", "data"]),
        caseBankAccountsStatus: state.caseDetails.getIn([Number(params.caseId), "caseBankAccounts", "status"]),
        caseBankAccounts: state.caseDetails.getIn([params.caseId, "caseBankAccounts", "data"]),
        gstinSearchListStatus: state.caseDetails.getIn([params.caseId, "gstinSearchListStatus"]),
        deleteAssociateStatus: state.caseDetails.getIn([Number(params.caseId), "caseAssociates", "deleteAssociateStatus"]),
        files: state.documents
            .getIn(["company_documents", companyId, "data"], Map({}))
            .map(_ => _.get("data"))
            .filter(_ => _.is_active)
            .sort((a, b) => (a.modified_date.isBefore(b.modified_date) ? 1 : -1))
            .toList(),
        all_enums: state.companies.get("enums"),
        camEngineStatus: state.companyLosProfiles.get("camEngineStatus"),
        camEngineViewData: state.companyLosProfiles.getIn(["camEngineData", Number(params.caseId)]),
        camEngineCommentsStatus: state.companyLosProfiles.get("camEngineCommentsStatus"),
        camEngineCommentsData: state.companyLosProfiles.getIn(["camEngineCommentsData", Number(params.caseId)]),
        camEngineStatusLogsStatus: state.companyLosProfiles.get("camEngineStatusLogsStatus"),
        camEngineStatusLogsData: state.companyLosProfiles.getIn(["camEngineStatusLogsData", Number(params.caseId)]),
        portfolioViewData: state.companyLosProfiles.getIn(["portfolioViewData", Number(params.caseId)]),
        portfolioViewStatus: state.companyLosProfiles.get("portfolioViewStatus"),
        camEngineData: state.companyLosProfiles.getIn(["camEngineData", Number(params.caseId)]),
        camEngineDataGroup: state.companyLosProfiles.getIn(["camEngineDataGroup", Number(params.caseId)]),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCompanyDocuments,
            fetchCaseDetail,
            fetchCompanyProfile,
            initiateCaseState,
            proceedCase,
            referCase,
            rejectCase,
            updateCaseType,
            assignCase,
            fetchCaseAssociates,
            fetchCaseBankAccounts,
            GstinsearchList,
            updateCaseAssociateStatus,
            fetchEnums,
            fetchCamEngineView,
            fetchPortfolioView,
            fetchCamEngineViewComments,
            fetchCamEngineStatusLogs
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FounderCaseDetailsDrawer);
